/**
 * Display-only label for the pass-through fee (PLAT-7419).
 *
 * The API still emits "Platform Fee" / "Platform fee" for pass-through fee
 * lines (Stripe invoice items and backend matchers depend on that text), but
 * users should see "Processing Fee". Only an exact (case-insensitive) match is
 * remapped so org product names that merely contain the words are untouched.
 */
export const PROCESSING_FEE_LABEL = "Processing Fee";

export function displayFeeLabel<T extends string | null | undefined>(
  text: T,
): T | string {
  if (typeof text !== "string") return text;
  const trimmed = text.trim();
  if (trimmed.toLowerCase() !== "platform fee") return text;
  return trimmed === "Platform fee" ? "Processing fee" : PROCESSING_FEE_LABEL;
}
